import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./mocks/mocks";
import "./styles/zinnes-theme.css";
import store from "./store/store";
import { isSensitiveAuthRoute, sanitizeAnalyticsLocation } from "@/utils/authNavigationPrivacy";

Vue.config.productionTip = false;

const GA_MEASUREMENT_ID = "G-VMKN52WXZE";
router.afterEach((to) => {
  if (typeof window.gtag !== "function" || isSensitiveAuthRoute(to)) {
    return;
  }

  Vue.nextTick(() => {
    window.gtag("event", "page_view", {
      send_to: GA_MEASUREMENT_ID,
      page_path: to.path,
      page_location: sanitizeAnalyticsLocation(window.location.href),
      page_title: document.title,
    });
  });
});

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
